(function () {
  "use strict";

  const debug = false;
  let cartCookie;

  const log = (text) => {
    if (debug) console.log(text);
  };

  const productSection = document.getElementsByClassName("frete-produto");
  if (!productSection.length) {
    log("Could not find the element");
    return;
  }

  let productSelect = document.getElementById("ProductSelect-product-template");
  if (!productSelect) {
    productSelect = document.getElementsByName("id")[0];
    if (!productSelect) {
      log("Could not find the main select element");
      return;
    }
  }

  const shippingMessage = document.createElement("p");
  const shippingCountry = document.createElement("select");
  const shippingProvince = document.createElement("select");
  const shippingZip = document.createElement("input");
  const freteLista = document.createElement("div");

  shippingMessage.classList.add("erros-fretes");
  shippingMessage.style.display = "none";
  freteLista.classList.add("listas-de-fretes");
  freteLista.style.display = "none";

  function setCepMask(input) {
    input.addEventListener("input", (e) => {
      let value = e.target.value.replace(/\D/g, "").slice(0, 8);
      if (value.length > 5) {
        e.target.value =
          value.slice(0, 2) + "." + value.slice(2, 5) + "-" + value.slice(5);
      } else if (value.length > 2) {
        e.target.value = value.slice(0, 2) + "." + value.slice(2);
      } else {
        e.target.value = value;
      }
    });
  }

  const initFields = () => {
    shippingCountry.id = "pais-simulator";
    ["Brazil"].forEach((country) => {
      shippingCountry.add(new Option(country, country, true));
    });
    shippingCountry.name = "shipping_address[country]";

    shippingProvince.id = "estados-simulator";
    [
      "Acre",
      "Alagoas",
      "Amapa",
      "Amazonas",
      "Bahia",
      "Ceara",
      "Distrito Federal",
      "Espirito Santo",
      "Goias",
      "Maranhao",
      "Mato Grosso",
      "Mato Grosso do Sul",
      "Minas Gerais",
      "Para",
      "Paraiba",
      "Parana",
      "Pernambuco",
      "Piaui",
      "Rio de Janeiro",
      "Rio Grande do Norte",
      "Rio Grande do Sul",
      "Rondonia",
      "Roraima",
      "Santa Catarina",
      "Sao Paulo",
      "Sergipe",
      "Tocantins",
    ].forEach((province) => {
      shippingProvince.add(new Option(province, province));
    });
    shippingProvince.name = "shipping_address[province]";

    shippingZip.type = "text";
    shippingZip.name = "shipping_address[zip]";
    shippingZip.className = "Form__Input cep-calculo-frete form-control";
    shippingZip.placeholder = "DIGITE SEU CEP";
    setCepMask(shippingZip);

    const shippingCalcWrapper = document.createElement("div");
    shippingCalcWrapper.className = "shipping-calc-wrapper";

    const formularioFrete = document.createElement("div");
    formularioFrete.className = "formulario-frete";

    const shippingCalcTitle = document.createElement("p");
    shippingCalcTitle.innerText = "Simule seu frete";

    const shippingCalcButton = document.createElement("a");
    shippingCalcButton.innerText = "Calcular";
    shippingCalcButton.className = "btn btn-underline button--primary button";

    shippingCalcButton.onclick = function () {
      const cepLimpo = shippingZip.value.replace(/\D/g, "");

      shippingMessage.innerHTML = "";
      shippingMessage.style.display = "none";

      fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
        .then((response) => response.json())
        .then((dados) => {
          if (!dados.erro) {
            const ufMap = {
              AC: "Acre",
              AL: "Alagoas",
              AP: "Amapa",
              AM: "Amazonas",
              BA: "Bahia",
              CE: "Ceara",
              DF: "Distrito Federal",
              ES: "Espirito Santo",
              GO: "Goias",
              MA: "Maranhao",
              MT: "Mato Grosso",
              MS: "Mato Grosso do Sul",
              MG: "Minas Gerais",
              PA: "Para",
              PB: "Paraiba",
              PR: "Parana",
              PE: "Pernambuco",
              PI: "Piaui",
              RJ: "Rio de Janeiro",
              RN: "Rio Grande do Norte",
              RS: "Rio Grande do Sul",
              RO: "Rondonia",
              RR: "Roraima",
              SC: "Santa Catarina",
              SP: "Sao Paulo",
              SE: "Sergipe",
              TO: "Tocantins",
            };
            shippingProvince.value = ufMap[dados.uf] || dados.uf;

            if (!productSelect.value) {
              console.log("Nenhuma variação selecionada");
            }

            cartCookie = getCookie("cart");
            const tempCookieValue = "temp-cart-cookie___" + Date.now();
            const fakeCookieValue = "fake-cart-cookie___" + Date.now();

            if (!cartCookie) {
              log("no cookie found");
              updateCartCookie(tempCookieValue);
              cartCookie = getCookie("cart");
            }

            if (cartCookie.length < 32) {
              log("cart ID not valid");
              return;
            }

            updateCartCookie(fakeCookieValue);

            const variantId = productSelect.value
              ? parseInt(productSelect.value)
              : parseInt(productSelect.options[1].value);

            getRates(variantId);
          } else {
            freteLista.innerHTML = "";
            shippingMessage.innerHTML = "Cep não encontrado, tente novamente.";
            shippingMessage.style.display = "flex";
          }
        })
        .catch(() => {
          freteLista.innerHTML = "";
          shippingMessage.innerHTML = "Cep não encontrado, tente novamente.";
          shippingMessage.style.display = "flex";
        });
    };

    formularioFrete.appendChild(shippingCountry);
    formularioFrete.appendChild(shippingProvince);
    formularioFrete.appendChild(shippingZip);
    formularioFrete.appendChild(shippingCalcButton);

    shippingCalcWrapper.appendChild(formularioFrete);
    shippingCalcWrapper.appendChild(shippingMessage);
    shippingCalcWrapper.appendChild(freteLista);

    productSection[0].appendChild(shippingCalcWrapper);
  };

  const getCookie = (name) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  const updateCartCookie = (value) => {
    log("changing cart cookie value to: " + value);
    const date = new Date();
    date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);
    const expires = "; expires=" + date.toGMTString();
    document.cookie = "cart=" + value + expires + "; path=/";
  };

  const resetCartCookie = () => {
    updateCartCookie(cartCookie);
    log(getCookie("cart"));
  };

  const getRates = (variantId) => {
    freteLista.innerHTML = "";
    freteLista.style.display = "block";

    if (typeof variantId === "undefined") return;

    const quantity = document.getElementById("Quantity")
      ? parseInt(document.getElementById("Quantity").value)
      : 1;

    const addData = { id: variantId, quantity };

    fetch("/cart/add.js?_easygift_internal=true", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      body: JSON.stringify(addData),
    })
      .then((res) => res.json())
      .then(() => {
        const loadingIcon = document.createElement("img");
        loadingIcon.src =
          "https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543";
        loadingIcon.width = 30;
        loadingIcon.style.margin = "0 auto";
        freteLista.appendChild(loadingIcon);

        fetch(
          `/cart/shipping_rates.json?_easygift_internal=true?country=${shippingCountry.value}&province=${shippingProvince.value}&zip=${shippingZip.value}`
        )
          .then((res) => res.json())
          .then((data) => {
            freteLista.innerHTML = "";
            if (data.shipping_rates && data.shipping_rates.length) {
              data.shipping_rates.forEach((rate) => {
                const utilDays = rate.delivery_days[1] || 0;
                const deliveryDays =
                  utilDays > 0
                    ? `${utilDays} dia${utilDays > 1 ? "s" : ""} útil${
                        utilDays > 1 ? "s" : ""
                      }`
                    : "";

                const valorFrete =
                  rate.price === "0.00" || rate.price === null
                    ? "Grátis"
                    : Shopify.formatMoney(rate.price, window.money_format);

                const freteItem = document.createElement("div");
                freteItem.className = "frete-item";

                freteItem.innerHTML = `
                  <div>
                    <p class="m-0 nome-frete"><b>${rate.name}</b> 
                      <span class="estimativa-de-entrega">${deliveryDays}</span>
                    </p>
                  </div>
                  <div class="frete-valor">Valor: <b>${valorFrete}</b></div>
                `;

                freteLista.appendChild(freteItem);
              });
            } else {
              freteLista.innerHTML = "Nenhuma opção de frete encontrada.";
            }
            resetCartCookie();
          })
          .catch(() => {
            resetCartCookie();
            freteLista.innerHTML = "";
            shippingMessage.innerHTML = "Cep não encontrado, tente novamente.";
            shippingMessage.style.display = "flex";
          });
      })
      .catch((err) => {
        console.error(err);
        resetCartCookie();
      });
  };

  initFields();
})();
